(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["QQ-ComparisonTable"] && !window.DesignMode) return;
  try {
    "use strict";function _typeof(e){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}!function(){function t(){var e=document.querySelectorAll(".qq-comparison-table-section .QQ-JS-init-msg");e&&e.forEach(function(e){e.remove()})}var n;function o(){(n=document.getElementsByClassName("qq-comparison-table-section")).length&&function e(){{var t,n,o;null==("undefined"==typeof $?"undefined":_typeof($))||null==window.$?((t=document.createElement("script")).id="qq-jquery",document.head.appendChild(t),t.type="text/javascript",t.src="https://code.jquery.com/jquery-3.6.0.min.js",t.onload=function(){e()}):document.getElementById("qq-slick")&&document.getElementById("qq-slick-css")?(n=setInterval(function(){$.fn.slick&&(clearInterval(n),i())},10),$(window).on("resize orientationchange",function(){i()})):(document.getElementById("qq-slick")||((o=document.createElement("script")).id="qq-slick",document.head.appendChild(o),o.type="text/javascript",o.src="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js",o.onload=function(){e()}),document.getElementById("qq-slick-css")||((o=document.createElement("link")).id="qq-slick-css",document.head.appendChild(o),o.type="text/css",o.rel="stylesheet",o.href="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css"))}}()}function i(){for(var e=0;e<n.length;e++)!function(e){var n=$("#"+e+" .qq-comparison-columns-mobile .qq-comparison-table-slider");{var t,o,i,c,r,l;"slider"==n.attr("data-navigation")?(t=Number(n.attr("data-mobileColumns")),Number(n.attr("data-mobileColumnsMargin")),o=!1,i=$("html").attr("dir"),c=$("html").css("direction"),(null!=i&&"rtl"==i||null!=_typeof(c)&&"rtl"==c)&&(o=!0,null==i&&$("html").attr("dir","rtl")),r=$("#"+e+" .qq-arrow-prev"),l=$("#"+e+" .qq-arrow-next"),850<$(window).width()?n.hasClass("slick-initialized")&&n.slick("unslick"):n.hasClass("slick-initialized")||n.on("init reInit setPosition afterChange",function(){setTimeout(function(){var e=n.find(".qq-comparison-column.slick-current.slick-active .qq-ct--cell.qq-header-cell"),t=r.attr("data-top"),t=e.outerHeight(!0)/2-t+16;r.add(l).css("top",t+"px")},200)}).slick({arrows:!0,rtl:o,centerMode:!1,prevArrow:r,nextArrow:l,draggable:!0,swipe:!0,slidesToShow:t,slidesToScroll:t})):$("#"+e+" .qq-mobile-scroll-wrapper.for-sticky").length&&function(){function e(){var e,t,n,o,i,c=document.getElementsByClassName("sync"+y);for(i in w)if(w.hasOwnProperty(i))for(e=0;e<w[i][h];e++)w[i][e]["remove"+r](y,w[i][e].syn,0);for(e=0;e<c[h];)if(o=t=0,i=(n=c[e++]).getAttribute("name")){for(n=n[y+"er"]||n;t<(w[i]=w[i]||[])[h];)o|=w[i][t++]==n;o||w[i].push(n),n.eX=n.eY=0,function(a,d){a[l](y,a.syn=function(){var e,t=w[d],n=a[y+p],o=a[y+f],i=n/(a[y+u]-a[q+u]),c=o/(a[y+m]-a[q+m]),r=n!=a.eX,l=o!=a.eY,s=0;for(a.eX=n,a.eY=o;s<t[h];)(e=t[s++])!=a&&(r&&v(e[y+p]-(n=e.eX=v(i*(e[y+u]-e[q+u]))))&&(e[y+p]=n),l&&v(e[y+f]-(o=e.eY=v(c*(e[y+m]-e[q+m]))))&&(e[y+f]=o))},0)}(n,i)}}var u="Width",m="Height",f="Top",p="Left",y="scroll",q="client",r="EventListener",l="add"+r,h="length",v=Math.round,w={};"complete"==document.readyState?e():window[l]("load",e,0)}()}}("qq"+n[e].id.replace("template--","").replace("shopify-section-","").replace("__",""))}window.addEventListener("shopify:section:load",function(e){t()}),t(),"loading"!==document.readyState?o():document.addEventListener("DOMContentLoaded",function(){o()}),window.addEventListener("shopify:section:load",function(e){o()}),window.addEventListener("shopify:block:select",function(e){})}();
  } catch(e) { console.error(e); }
})();
})();
